// AUTOGENERATED
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dAnalytics$dTypes$dCheckoutTrackingItem from "../Restaumatic.Analytics.Types.CheckoutTrackingItem/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(Restaumatic$dAnalytics$dTypes$dCheckoutTrackingItem.eqCheckoutTrackingItem.eq))();
const itemsIsSymbol = {reflectSymbol: () => "items"};
const CheckoutTrackingDataIsSymbol = {reflectSymbol: () => "CheckoutTrackingData"};
const CheckoutTrackingData = x => x;
const toFillFormTypeCheckoutTra = {fillFormDataType: v => "unknown"};
const newtypeCheckoutTrackingDa = {Coercible0: () => {}};
const hasFieldCheckoutTrackingD = dictHasField => dictHasField;
const eqCheckoutTrackingData = {eq: x => y => eq(x.items)(y.items)};
const genericCheckoutTrackingData = {to: x => x, from: x => x};
const showCheckoutTrackingData = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dAnalytics$dTypes$dCheckoutTrackingItem.showCheckoutTrackingItem.show);
      return {genericShowArgs: v => ["{ items: " + $0(v.items) + " }"]};
    })())(CheckoutTrackingDataIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCheckoutTrackingData = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(itemsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dAnalytics$dTypes$dCheckoutTrackingItem.unscrambleDecodeCheckoutTrackingItem.unsafeDecode)
    })(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeCheckoutTrackingData = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCheckoutTrackingData)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CheckoutTrackingDataIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(itemsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dAnalytics$dTypes$dCheckoutTrackingItem.encodeCheckoutTrackingItem.encode);
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeCheckoutTrackingData = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCheckoutTrackingData)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CheckoutTrackingDataIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(itemsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dAnalytics$dTypes$dCheckoutTrackingItem.decodeCheckoutTrackingItem).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  CheckoutTrackingData,
  CheckoutTrackingDataIsSymbol,
  decodeCheckoutTrackingData,
  encodeCheckoutTrackingData,
  eq,
  eqCheckoutTrackingData,
  genericCheckoutTrackingData,
  hasFieldCheckoutTrackingD,
  itemsIsSymbol,
  newtypeCheckoutTrackingDa,
  showCheckoutTrackingData,
  toFillFormTypeCheckoutTra,
  unscrambleDecodeCheckoutTrackingData
};
